<template>
    <div class="screen-only">
        <router-link :to="{name: 'welcomeview', params: {eventId: eventId}}"
            :class="'welcomeview' == this.$route.name ? 'current-view' : ''">Welcome</router-link>
        <span v-show="visibilities.isVisibilitySet">
            <span v-if="visibilities.showScheduleLink">
                &nbsp;|&nbsp;<router-link :to="{name: 'scheduleview', params: {eventId: eventId}}"
                                    :class="'scheduleview' == this.$route.name ? 'current-view' : ''">Schedule</router-link>
            </span>
            <span v-if="visibilities.showMyScheduleLink">
                &nbsp;|&nbsp;<router-link :to="{name: 'myscheduleview', params: {eventId: eventId}}"
                                    :class="'myscheduleview' == this.$route.name ? 'current-view' : ''">My schedule</router-link>
            </span>
            <span v-if="visibilities.showPresentersLink">
                &nbsp;|&nbsp;<router-link :to="{name: 'presentersview', params: {eventId: eventId}}"
                                    :class="'presentersview' == this.$route.name ? 'current-view' : ''">Presenters</router-link>
            </span>
            <span v-if="visibilities.showMaterialsLink">
                &nbsp;|&nbsp;<router-link :to="{name: 'eventmaterialsview', params: {eventId: eventId}}"
                                    :class="'eventmaterialsview' == this.$route.name ? 'current-view' : ''">Materials</router-link>
            </span>
            <span v-if="visibilities.showCreditLink">
                &nbsp;|&nbsp;<router-link :to="{name: 'creditview', params: {eventId: eventId}}"
                                    :class="'creditview' == this.$route.name ? 'current-view' : ''">Credit</router-link>
            </span>
            <span v-if="visibilities.showFacilitatorGuideLink">
                &nbsp;|&nbsp;<router-link :to="{name: 'facilitatorguideview', params: {eventId: eventId}}"
                                    :class="'facilitatorguideview' == this.$route.name ? 'current-view' : ''">Facilitator Guide</router-link>
            </span>
            <span v-if="visibilities.showVenuesLink">
                &nbsp;|&nbsp;<router-link :to="{name: 'eventvenuesview', params: {eventId: eventId}}"
                                    :class="'eventvenuesview' == this.$route.name ? 'current-view' : ''">Venues</router-link>
            </span>
            <span v-if="visibilities.showExhibitorsLink">
                &nbsp;|&nbsp;<router-link :to="{name: 'eventexhibitorsview', params: {eventId: eventId}}"
                                    :class="'eventexhibitorsview' == this.$route.name ? 'current-view' : ''">Exhibitors</router-link>
            </span>
            <span v-if="visibilities.showPartnersLink">
                &nbsp;|&nbsp;<router-link :to="{name: 'eventpartnersview', params: {eventId: eventId}}"
                                    :class="'eventpartnersview' == this.$route.name ? 'current-view' : ''">Partners</router-link>
            </span>
        </span>
    </div>
</template>

<script>
import {useEventsStore} from '@/store/events'

export default {
    name: 'EventNavigation',

    mounted() {
        const eventsStore = useEventsStore()
        if (null == eventsStore.scheduleRoute) {
            eventsStore.scheduleRoute = 'myscheduleview'
        }
        this.scheduleRoute = eventsStore.scheduleRoute

        if (0 > this.$route.name.indexOf('schedule')) {
            this.scheduleLinkStyle = ''
        } else {
            this.scheduleLinkStyle = 'current-view'
            eventsStore.scheduleRoute = this.$route.name 
        }
    },

    data() {
        return {
            scheduleRoute: 'scheduleview',
            scheduleLinkStyle: '',
        }
    },

    props: {
        eventId: {
            type: Number,
            required: true,
        },
        visibilities: {
            type: Object,
            default: () => ({
                isVisibilitySet: false,
                showCreditLink: true,
                showFacilitatorGuideLink: true,
                showExhibitorsLink: true,
                showMyScheduleLink: true,
                showrPartnersLink: true,
                showPresentersLink: true,
                showScheduleLink: true,
                showVenuesLink: true,
            })
        },
    },
}
</script>

<style scoped>

.current-view {
    color: var(--phoenix-1100);
    font-weight: normal;
}

p {
    font-weight: bold;
    margin-left: 0.25rem;
}

.screen-only {
    margin-bottom: 0.5rem;
}

</style>